



























































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateSwitchModel from "./createswitchmodel.vue";
import EditSwitchModel from "./editswitchmodel.vue";
import CopySwitchModel from "./copyswitchmodel.vue";
import SwitchModelPO from "@/store/entities/devices/switchs/switchmodelpo";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PageMeterModelRequest extends PageRequest {
  keyword: string;
  areaId: number;
}

@Component({
  components: { CreateSwitchModel, EditSwitchModel, CopySwitchModel },
})
export default class SwtichModel extends AbpBase {
  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageMeterModelRequest = new PageMeterModelRequest();
  columnlist: any[] = [];
  searchName: string = ""; //树形搜索名称
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  copyModalShow: boolean = false;
  menuId: number = 0;
  choosecolumn: any[] = [];
  switchmodelpo: SwitchModelPO = new SwitchModelPO();
  splitnum: number = 0.15;

  showcolumn: boolean = false; //显示列选择窗口
  //获取菜单Id
  getmenu() {
    let menulist = JSON.parse(localStorage.getItem("userAuth"));
    let menu = menulist.filter((ele) => {
      return ele.value == "switchmodel";
    });
    if (menu.length > 0) {
      this.menuId = menu[0].id;
    }
    let se = this.columns.filter((ele) => {
      return ele.sortId == 0 || ele.sortId == 1;
    });
    se.forEach((ele) => {
      this.columnlist.push(ele);
    });
  }
  //获取自定义字段
  async getuserfields() {
    let res = await this.$store.dispatch({
      type: "userfield/getuserfield",
      data: { menuId: this.menuId },
    });
    //把列加入右边列表
    this.columns.forEach((ele) => {
      if (ele.sortId != 0 && ele.sortId != 1 && ele.sortId != 37) {
        this.choosecolumn.push({
          fieldName: ele.key,
          isShow: true,
          sortCode: ele.sortId,
          showTag: ele.title,
        });
      }
    });
    //如果设置了自定义列
    if (res.length > 0) {
      let restrue = res.filter((ele) => {
        return ele.isShow == true;
      });
      //this.choosecolumn = res;
      restrue.forEach((ele) => {
        let col = this.columns.filter((colum) => {
          return colum.key == ele.fieldName;
        });
        //加入显示列
        if (col.length > 0) {
          col[0].sortId = ele.sortCode;
          this.columnlist.push(col[0]);
        }
      });
      this.choosecolumn.forEach((ele) => {
        let col = restrue.filter((colum) => {
          return colum.fieldName == ele.fieldName;
        });
        if (col.length > 0) {
          ele.isShow = col[0].isShow;
        }
      });
    } else {
      this.columnlist = this.columns;
    }
    this.columnlist.sort((left, right): number => {
      if (left.sortId > right.sortId) return 1;
      if (left.sortId < right.sortId) return -1;
      return 0;
    });
  }
  //改变显示
  handleChange(event: any, val: any) {
    if (event) {
      //选中显示
      let showcol = this.columns.filter((col) => {
        return col.key === val;
      });
      if (showcol.length > 0) {
        let sh = this.choosecolumn.filter((p) => {
          return p.fieldName == val;
        });
        if (sh.length > 0) {
          showcol[0].sortId = sh[0].sortCode;
        }
        this.columnlist.push(showcol[0]);
      }
    } else {
      //不显示
      this.columnlist = this.columnlist.filter((col) => {
        return col.key !== val;
      });
    }
    //排序
    this.columnlist.sort((left, right): number => {
      if (left.sortId > right.sortId) return 1;
      if (left.sortId < right.sortId) return -1;
      return 0;
    });
  }
  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  get list() {
    return this.$store.state.switchmodel.list;
  }
  get loading() {
    return this.$store.state.switchmodel.loading;
  }
  create() {
    this.createModalShow = true;
  }
  showcol() {
    this.showcolumn = true;
  }
  isActiveChange(val: number) {
    this.$store.commit("switchmodel/setCurrentPage", 1);
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("switchmodel/setCurrentPage", 1);
    this.getpage();
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    const rebuildData = (value, treeList) => {
      let newarr = [];
      treeList.forEach((element) => {
        if (element.children && element.children.length) {
          if (element.title != null && element.title.indexOf(value) > -1) {
            element.expand = true;
            newarr.push(element);
          }
          const ab = rebuildData(value, element.children);
          const obj = {
            ...element,
            expand: true,
            children: ab,
          };
          if (ab && ab.length) {
            newarr.push(obj);
          }
        } else {
          if (element.title != null && element.title.indexOf(value) > -1) {
            newarr.push(element);
          }
        }
      });
      return newarr;
    };
    this.areaTree = [];
    this.areaTree = rebuildData(value, this.areaTreeList);
  }
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  pageChange(page: number) {
    this.$store.commit("switchmodel/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("switchmodel/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "switchmodel/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.switchmodel.pageSize;
  }
  get totalCount() {
    return this.$store.state.switchmodel.totalCount;
  }
  get currentPage() {
    return this.$store.state.switchmodel.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 60,
      align: "left",
      fixed: "left",
      title: this.L("IndexNo"),
      sortId: 0,
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 130,
      sortId: 2,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: info.length > 0 ? info[0].displayName : this.L("Unknown"),
            },
          },
          info.length > 0 ? info[0].displayName : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      width: 130,
      sortable: true,
      sortId: 3,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: info.length > 0 ? info[0].fullName : this.L("Unknown"),
            },
          },
          info.length > 0 ? info[0].fullName : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("Name"),
      key: "name",
      width: 130,
      fixed: "left",
      sortable: true,
      sortId: 4,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.name,
            },
          },
          params.row.name
        );
      },
    },
    {
      title: this.L("Transfer"),
      key: "transferType",
      sortable: true,
      width: 130,
      sortId: 5,
      render: (h: any, params: any) => {
        let id = params.row.transferType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("DeviceType"),
      key: "deviceTypeId",
      width: 130,
      sortable: true,
      sortId: 7,
      render: (h: any, params: any) => {
        let id = params.row.deviceTypeId;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: info.length > 0 ? info[0].name : this.L("Unknown"),
            },
          },
          info.length > 0 ? info[0].name : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("ISP"),
      key: "isp",
      sortable: true,
      width: 130,
      sortId: 9,
      render: (h: any, params: any) => {
        let id = params.row.isp;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: "AppId",
      key: "appId",
      width: 130,
      sortId: 19,
    },
    {
      title: "AppSecret",
      key: "appSecret",
      width: 130,
      sortId: 20,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.appSecret },
            },
            params.row.appSecret
          ),
        ]);
      },
    },
    {
      title: this.L("Protocol"),
      key: "protocol",
      sortable: true,
      width: 130,
      sortId: 21,
      render: (h: any, params: any) => {
        let id = params.row.protocol;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("Tenants") + "Id",
      key: "aepTenantId",
      width: 130,
      sortId: 24,
    },
    {
      title: this.L("Product") + "Id",
      key: "productId",
      width: 130,
      sortId: 25,
    },
    {
      title: this.L("MasterId"),
      key: "masterId",
      width: 130,
      sortId: 26,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.masterId,
            },
          },
          params.row.masterId
        );
      },
    },
    {
      title: this.L("Manufacturer") + "Id",
      key: "manufacturerId",
      width: 130,
      sortId: 27,
    },
    {
      title: this.L("Manufacturer") + this.L("Name"),
      key: "manufacturerName",
      width: 130,
      sortId: 28,
    },
    {
      title: this.L("Device") + this.L("Model"),
      key: "deviceModel",
      width: 130,
      sortId: 29,
    },
    {
      title: this.L("Object") + "Id",
      key: "obj_Id",
      width: 130,
      sortId: 30,
    },
    {
      title: this.L("Inst") + "Id",
      key: "obj_Inst_id",
      width: 130,
      sortId: 31,
    },
    {
      title: this.L("Resource") + "Id",
      key: "res_Id",
      width: 130,
      sortId: 32,
    },
    {
      title: this.L("IsActive"),
      key: "isEnable",
      width: 130,
      sortId: 33,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Yes") : this.L("No")
        );
      },
    },
    {
      title: this.L("SortName"),
      key: "sortCode",
      width: 130,
      sortId: 34,
    },
    {
      title: this.L("Description"),
      key: "description",
      width: 130,
      sortId: 35,
    },
    {
      title: "Id",
      key: "id",
      width: 130,
      sortId: 36,
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 180,
      sortId: 37,
      fixed: "right",
      render: (h: any, params: any) => {
        let del = this.checkButtonAuth('switchmodelDel');
        let edit = this.checkButtonAuth('switchmodelEdit');
        let copy = this.checkButtonAuth('switchmodelCopy')
        return h("div", [
          copy ? h(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("switchmodel/edit", params.row);
                  this.copy();
                },
              },
            },
            this.L("Copy")
          ) : '',
          edit ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("switchmodel/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ) : '',
          del ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "switchmodel/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ) : '',
        ]);
      },
    },
  ];
  async created() {
    this.getmenu();
    await this.getuserfields();
    this.getpage();
    this.getAreaTree();
    this.getItemDetail();
  }
  data() {
    return {
      ispdetail: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      let isp = detaillist.filter((p) => {
        return p.itemId == 3;
      });
      isp.forEach((ele) => {
        this.$data.ispdetail.push({
          label: ele.name,
          value: ele.id,
        });
      });
      //console.log(isp)
    }
  }
  //复制
  async copy() {
    this.copyModalShow = true;
  }
}
